<template>
<div>
	<header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">เกี่ยวกับ Bottom Menu</h1>
    </header>


<div class="MarkdownContent hidden-sm-and-down" style="width: 70vw;">


<v-layout row wrap>
      <v-flex xl3 lg3 md3 style="text-align: center;">
    <div style="text-align: center;">
      <img src="/static/bot component/bottommenu/bottom menu video.gif" style="width: 170px;" />
    </div>
  </v-flex>
        <v-flex xl9 lg9 md9 style="text-align: left;">
      <br>
      <br>
      <p class="preindent" style="width: 70%; margin-top: 40px;"> Bottom Menu เป็นตัวช่วยแนะนำความสามารถของบอทเพื่อให้ผู้ใช้ใช้งานได้สะดวกมากขึ้น โดยจะแสดงเป็นแถบเมนูด้านล่าง ซึ่งเจ้าของบอทเป็นผู้กำหนดรูปแบบการแสดงผลขอเมนู
      </p>
      <p class="preindent" style="width: 70%;"> ปัจจุบันทางวันแชทมี Bottom Menu ให้เลือกใช้งานถึง 12 รูปแบบ แบ่งออกเป็น 2 รูปแบบใหญ่ๆ ได้แก่</p>
      <p class="preindent" style="width: 70%;"> - แบบแถวเดียว </p>
      <p class="preindent" style="width: 70%;"> - แบบ 2 แถว </p>

  </v-flex>
</v-layout>
</div>

<div class="MarkdownContent hidden-md-and-up">
      <p class="preindent"> Bottom Menu เป็นตัวช่วยแนะนำความสามารถของบอทเพื่อให้ผู้ใช้ใช้งานได้สะดวกมากขึ้น โดยจะแสดงเป็นแถบเมนูด้านล่าง ซึ่งเจ้าของบอทเป็นผู้กำหนดรูปแบบการแสดงผลขอเมนู </p>
      <p class="preindent"> ปัจจุบันทางวันแชทมี Bottom Menu ให้เลือกใช้งานถึง 12 รูปแบบ แบ่งออกเป็น 2 รูปแบบใหญ่ๆ ได้แก่ </p>
      <p class="preindent"> - แบบแถวเดียว </p>
      <p class="preindent"> - แบบ 2 แถว </p>
    </div>

<div style="text-align: center;" class="hidden-md-and-up">
      <img src="/static/bot component/bottommenu/bottom menu video.gif" style="width: 70vw;" />
    </div>


<v-layout row wrap>
      <v-flex xl9 lg9 md9 >

<h3 class="preindent"> - แบบแถวเดียว </h3>
<div style="margin-left: 100px;">
<!-- <img src="/static/bot component/bottommenuwithsize/bottommenu1row.png" style="width: 1000px;" /> -->
<img src="/static/bot component/bottommenuwithsize/bottommenu1row1.png" style="width: 1000px;" />
</div>
<h3 class="preindent"> - แบบ 2 แถว </h3>
<div style="margin-left: 100px;">
<img src="/static/bot component/bottommenuwithsize/bottommenu2row.png" style="width: 1000px;" />
</div>
<br>
<p class="preindent" > โดยในแต่ละช่องของ Bottom Menu เราสามารถกำหนดประเภทได้ดังนี้ </p>
<p class="preindent" > - <b>ประเภทข้อความ:</b> เมื่อผู้ใช้กดเมนูที่เป็นประเภทข้อความ จะเปรียบเสมือนผู้ใช้พิมพ์ข้อความถึงบอท </p>
<p class="preindent" > - <b>ประเภทลิงก์:</b> เมื่อผู้ใช้กดเมนูที่เป็นประเภทลิงก์ ทางonechatจะทำการเปิดเว็บไซต์ url ตามที่ได้settingไว้ โดยจะเป็นการเปิดเว็บไซต์ตาม webbrowser default ของแต่ละเครื่อง </p>
 <p class="preindent" style="margin-left: 50px;"> * หากต้องการเข้าถึงข้อมูลของผู้ใช้ โปรดเลือก ต้องการข้อมูลผู้ใช้งาน จากนั้นเลือกประเภทของข้อมูลผู้ใช้งาน</p>
  <p class="preindent" style="margin-left: 50px;"> - แบบ share token (วิธีการนำไปใช้ <a @click="dialogShareToken = true">กดที่นี่</a>)</p>
  <p class="preindent" style="margin-left: 50px;"> - แบบ onechat_token (วิธีการนำไปใช้ <a @click="dialoggetProfile = true">กดที่นี่</span>)</a>


<p class="preindent" > - <b>ประเภทเว็บวิว:</b> เมื่อผู้ใช้กดเมนูที่เป็นประเภทเว็บวิว จะคล้ายกับการกดเมนูประเภทลิงก์คือเป็นการเปิดลิงก์เว็บไซต์ url ตามที่ได้settingไว้ แต่จะแตกต่างกันที่การแสดงผล โดยเว็บวิวจะเป็นการนำเว็บไซต์ภายนอกมาแสดงผลในหน้าต่างหรือรูปแบบของonechat โดยการแสดงผลมีอยู่ด้วยกัน 3 ขนาด ดังนี้</p>

<img src="/static/bot component/sizewebview.jpg" style="width: 400px; margin-left: 100px;" />
 <p class="preindent" style="margin-left: 50px;"> * หากต้องการเข้าถึงข้อมูลของผู้ใช้ โปรดเลือก ต้องการข้อมูลผู้ใช้งาน จากนั้นเลือกประเภทของข้อมูลผู้ใช้งาน</p>
  <p class="preindent" style="margin-left: 50px;"> - แบบ share token (วิธีการนำไปใช้ <a @click="dialogShareToken = true">กดที่นี่</a>)</p>
  <p class="preindent" style="margin-left: 50px;"> - แบบ onechat_token (วิธีการนำไปใช้ <a @click="dialoggetProfile = true">กดที่นี่</span>)</a></p>

  <p class="preindent" > - <b>ประเภทโลเคชัน:</b> เมื่อผู้ใช้กดเมนูที่เป็นประเภทโลเคชัน ระบบจะดึงตำแหน่งปัจจุบันของผู้ใช้ส่งไปในห้องแชทนั้น</p>
  <p class="preindent" > - <b>ประเภทสแกนคิวอาร์โค้ด:</b> เมื่อผู้ใช้กดเมนูเป็นประเภทสแกนคิวอาร์โค้ด ระบบจะเปิดใช้งานกล้องจากอุปกรณ์ของผู้ใช้ เพื่อให้ผู้ใช้สามารถสแกนคิวอาร์โค้ดได้</p>
</v-flex>
</v-layout>
<HowtoGetProfileDialog :dialoggetProfile="dialoggetProfile" @closeDialoggetProfile="closeDialoggetProfile" />
<dialogShareToken :dialogShareToken="dialogShareToken" @closeDialogshareToken="closeDialogshareToken"/>
  </div>
</template>
<script>
import HowtoGetProfileDialog from '@/components/BottomMenu/HowtoGetProfileDialog'
import dialogShareToken from '@/components/BottomMenu/dialogShareToken'
export default {
  data: () => ({
    dialoggetProfile: false,
    dialogShareToken: false
    // path: '',
    // urlsendQuickreply: '',
    // message: '{\n\t"to": "U5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t"bot_id": "Ba521xx18350a5xxx2bxxxxx",\n\t"message": "โปรดเลือกอาหารที่คุณชอบมากที่สุด",\n\t"quick_reply": [ {....รูปแบบquick replyต่างๆ....} ]\n}'
  }),
  components: {
    HowtoGetProfileDialog,
    dialogShareToken
  },
  methods: {
    toPage (page) {
      this.$router.push(page)
    },
    closeDialoggetProfile (value) {
      this.dialoggetProfile = value
    },
    closeDialogshareToken (value) {
      this.dialogShareToken = value
    }
  },
  created () {
    // this.path = this.$router.currentRoute.path
    // this.urlsendQuickreply = process.env.APIimage + '/api/v1/push_quickreply'
  }
}
</script>

<style type="text/css">
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/docsbottommenu/about.vue